import request from "@/utils/request.js";

// 实有安防设施列表
export const securitylist = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/list",
    params: data || {}
  });
};
// 实有安防设施添加
export const securitysave = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/save",
    data: data || {},
    method: "POST"
  });
};

// 实有安防设施修改
export const securityupdate = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/update",
    data: data || {},
    method: "POST"
  });
};

// 实有安防设施删除
export const securitydelete = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/delete",
    data: data || {},
    method: "POST"
  });
};

// 实有安防设施详情
export const propertyinfo = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/info/" + data,
    params: data || {}
  });
};

// 实有安防设施统计
export const securitycount = data => {
  return request({
    url: "/api/hz-smart-community/security/facilities/count/",
    params: data || {}
  });
};

// 实有力量list
export const strengthlist = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/list",
    params: data || {}
  });
};
// 实有力量添加
export const strengthsave = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/save",
    data: data || {},
    method: "POST"
  });
};
// 实有力量修改
export const strengthupdate = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/update",
    data: data || {},
    method: "POST"
  });
};

// 实有力量删除
export const strengthinfodelete = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/delete",
    data: data || {},
    method: "POST"
  });
};

// 实有力量树添加
export const strengthgroupsave = data => {
  return request({
    url: "/api/hz-smart-community/strength/group/save",
    data: data || {},
    method: "POST"
  });
};

// 实有力量树添加后的数据
export const strengthgrouplist = data => {
  return request({
    url: "/api/hz-smart-community/strength/group/list",
    params: data || {}
  });
};

// 实有力量树修改
export const strengthgroupupdate = data => {
  return request({
    url: "/api/hz-smart-community/strength/group/update",
    data: data || {},
    method: "POST"
  });
};
// 实有力量树删除
export const strengthgroupdelete = data => {
  return request({
    url: "/api/hz-smart-community/strength/group/delete",
    data: data || {},
    method: "POST"
  });
};

// 负责人

export const strengthselect = data => {
  return request({
    url: "/api/hz-smart-community/strength/info/select",
    params: data || {}
  });
};
// 实有装备list
export const equipmentlist = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/list",
    params: data || {}
  });
};
// 实有装备添加
export const equipmentsave = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/save",
    data: data || {},
    method: 'POST'
  });
};
// 实有装备修改
export const equipmentupdate = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/update",
    data: data || {},
    method: 'POST'
  });
};

// 实有装备修改
export const equipmentdelete = data => {
  return request({
    url: "/api/hz-smart-community/equipment/info/delete",
    data: data || {},
    method: 'POST'
  });
};